import {Component, OnInit} from '@angular/core';
import {TourService} from 'ngx-tour-md-menu';
import {TutorialService} from './services/tutorial.service';
import {TutorialProgresso} from './models/tutorial';
import {ResponseBase} from './models/response-base';
import {ApiError} from './shared/enums/api-error.enum';
import { AuthenticationService } from './services/authentication.service';
import { Auth } from './models/auth';
import { Spinkit } from 'ng-http-loader';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css']
})

export class AppComponent {
    title = 'SeuVale-ModuloWeb';
    public spinkit = Spinkit;

    private progresso: TutorialProgresso;
    private currentUser: Auth;

    constructor(public tourService: TourService, private tutorialService: TutorialService, private authenticationService: AuthenticationService, ) {
        this.currentUser = this.authenticationService.currentUserValue;
    }

    tutorialNext(step: any) {
        if(!this.currentUser){
            this.currentUser = this.authenticationService.currentUserValue;
        }
        const tutorial = this.tutorialService.getLocalStoragePassos;

        this.progresso = new TutorialProgresso();
        this.tutorialService.getProgresso(this.currentUser.token.assignorGuid, this.currentUser.token.userReferenceId, 'homeCedente').subscribe((resp: ResponseBase<TutorialProgresso>) => {
            if (resp.status === ApiError.Sucesso) {
                /* console.log(resp.result) */

                this.progresso.ativo = resp.result.ativo;
                this.progresso.ordemAtividade = (resp.result.progresso / 20);
                this.progresso.idCedente = this.currentUser.token.assignorGuid;
                this.progresso.idGestor = this.currentUser.token.userReferenceId;
                this.progresso.nomeTutorial = 'homeCedente';
                if (this.progresso.ordemAtividade < 2) {
                    this.progresso.ordemAtividade++;
                    this.tutorialService.updateProgresso(this.progresso).subscribe(r => {
                        /* console.log(r) */
                    });
                }
            }
        }, error => {
            console.log(error);
        });
        if (tutorial) {
            if (this.tourService.hasNext(step)) {
                /* console.log(this.progresso) */


                this.tutorialService.setLocalStoragePassoAtual(tutorial.find(f => f.anchorId === step.anchorId + 1));
            }
        }
        this.tutorialService.setLocalStoragePassoAtual(step);

        if (!step.alreadyDone) {
            if (step.action) {
                this.tourService.end();
            } else {
                this.tourService.next();
            }
        } else {
            this.tourService.next();
        }
    }

    tutorialClosed() {
        if(!this.currentUser){
            this.currentUser = this.authenticationService.currentUserValue;
        }
        this.progresso = new TutorialProgresso();
        this.tutorialService.getProgresso(this.currentUser.token.assignorGuid, this.currentUser.token.userReferenceId, 'homeCedente').subscribe((resp: ResponseBase<TutorialProgresso>) => {
            if (resp.status === ApiError.Sucesso) {
                /* console.log(resp.result) */

                this.progresso.ativo = resp.result.ativo;
                this.progresso.ordemAtividade = 5;
                this.progresso.idCedente = this.currentUser.token.assignorGuid;
                this.progresso.idGestor = this.currentUser.token.userReferenceId;
                this.progresso.nomeTutorial = 'homeCedente';
                this.tutorialService.updateProgresso(this.progresso).subscribe(r => {
                    /* console.log(r) */

                });
            }
        }, error => {
            console.log(error);
        });
        this.tourService.end();
    }
}
